<template>
    <div class="bg-auth d-flex align-center">
        <v-container>
            <v-row>
                <v-col sm="12" md="6" lg="4">
                    <app-header-auth :title="header.title" :description="header.description" class="mb-12"></app-header-auth>
                    <app-redefine-password-form-auth class="pt-12"></app-redefine-password-form-auth>
                </v-col>
            </v-row>
        </v-container>
        <app-image-background-auth></app-image-background-auth>
    </div>
</template>

<script>
import AuthHeader from '../components/AuthHeader.vue'
import AuthImageBackground from '../components/AuthImageBackground.vue'
import AuthRedefinePasswordForm from '../components/AuthRedefinePasswordForm.vue'

export default {
    components: { 
        'app-header-auth': AuthHeader,
        'app-redefine-password-form-auth': AuthRedefinePasswordForm,
        'app-image-background-auth': AuthImageBackground
     },
    data: () => ({
        header: {
            title: 'Redefinir senha',
            description: 'Preencha com uma nova senha.' 
        }
    })
}
</script>

<style lang="scss">
    @import "../sass/__auth.scss"; 
</style>